import { inject, Injectable } from '@angular/core';
import { AppStateService } from '@libs/shared/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScannerUtilService {
  private readonly appStateService: AppStateService = inject(AppStateService);

  public getIsOrderMode(): Observable<boolean> {
    return this.appStateService.get('scannerOrderModeActive').pipe(map((value: boolean | undefined) => {
      if (!value) {
        return false;
      }

      return value;
    }));
  }

  public setIsOrderMode(isOrderMode: boolean): void {
    this.appStateService.set('scannerOrderModeActive', isOrderMode);
  }
}
